import { lazyLoad } from 'utils/loadable';

export const PayrollPage = lazyLoad(
  () => import('./Payroll'),
  module => module.Payroll,
);
